export default "__VITE_ASSET__tstwk3mO__"